import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, browserHistory, IndexRedirect } from 'react-router'
import './index.css';

import App from './containers/App'
import Splash from './containers/Splash'
import Setup from './containers/Setup'
import Live from './containers/Live'

ReactDOM.render((
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRedirect to="/splash" />
      <Route path="/splash" component={Splash} />
      <Route path="/setup" component={Setup} />
      <Route path="/live" component={Live} />
    </Route>
  </Router>
), document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/